import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

export function OfflineBanner() {
  const [state, setState] = useState(() => (navigator.onLine ? "online" : "offline"));
  useEffect(() => {
    let t;
    const off = () => { clearTimeout(t); setState("offline"); };
    const on = () => { setState("back"); t = setTimeout(() => setState("online"), 3000); };
    window.addEventListener("offline", off);
    window.addEventListener("online", on);
    return () => { window.removeEventListener("offline", off); window.removeEventListener("online", on); clearTimeout(t); };
  }, []);
  if (state === "online") return null;
  const offline = state === "offline";
  return (
    <div role="status" aria-live="polite" data-testid={offline ? "offline-banner" : "online-back-banner"}
      className={`fixed bottom-24 lg:bottom-6 inset-x-3 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 sm:w-[28rem] z-[9998] pointer-events-none rounded-2xl px-4 py-3 shadow-lg text-sm flex items-start gap-2.5 animate-fade-up ${offline ? "bg-amber-50 border border-amber-300 text-amber-900" : "bg-emerald-50 border border-emerald-300 text-emerald-800"}`}>
      {offline ? <WifiOff className="w-5 h-5 shrink-0" /> : <Wifi className="w-5 h-5 shrink-0" />}
      <span>{offline
        ? <><strong>Sin conexión.</strong> Revisa tu wifi o datos; seguiremos apenas vuelva internet.</>
        : <strong>¡Conexión recuperada!</strong>}</span>
    </div>
  );
}
